var debug = {
    dev: false,
    head: '&& EventActionPrototype'
};


// This is old and deprectaed
export default class EventActionProto {

    public uid            : ID
    public data           : any
    public companyId      : ID | false | undefined
    public restartApps    : any[]

    constructor(uid:string, data:any, companyId?:ID | false, sessionEvent?:any) {
        this.uid            = uid;
        this.data           = data;
        this.companyId      = companyId;
        this.restartApps    = [];
    }

    validate():boolean {
        return true;
    }

    isDifferentCompany() {
        return (this.companyId && this.companyId !== gd.companyId);
    }

    process() {

        if (debug.dev) console.log(debug.head, "POTENTIAL Restart apps:",this.restartApps,this.restartApps.length);

        if (this.restartApps && this.restartApps.length>0) {
            this.restartApps.map(function(appName){
                if (gd.app && gd.app.name===appName) {
                    if (debug.dev) console.log(debug.head,"restarting...",appName);
                    gd.app.start();
                }
            })
        }
    }

}